import { Container } from '@material-ui/core';
import React from 'react';
import HomeGrid from './HomeGrid';

export default function Home() {
  sessionStorage.clear();
  
  return (
    <Container>
      <HomeGrid />
    </Container>
  );
}
